<template>
	<v-container fluid fill-height>
		<v-flex class="d-flex align-center justify-center">
			<primary-card>
				<template v-slot:body>
					<v-row>
						<v-col :order="$vuetify.breakpoint.mdAndDown?'last':1">
							<info-panel/>
						</v-col>
						<v-col :order="$vuetify.breakpoint.mdAndDown?'first':2">
							<sign-in-form/>
						</v-col>
					</v-row>
				</template>
			</primary-card>
		</v-flex>
	</v-container>
</template>

<script>

import PrimaryCard from '@/components/PrimaryCard';

import SignInForm from '@/views/SignIn/SignInForm';
import InfoPanel from '@/views/SignIn/InfoPanel';

export default {
	name: 'SignIn',
	components: {
		PrimaryCard,
		SignInForm,
		InfoPanel
	}
};
</script>
